import http from './httpService';

export function getAllRisks(id) {
  return http.get(`/risks/${id}`);
}
